import { Component } from '@angular/core';
import { IntroductionComponent } from "../sections/introduction/introduction.component";
import { AboutComponent } from "../sections/about/about.component";
import { DevservicesComponent } from "../sections/devservices/devservices.component";

@Component({
  selector: 'app-home',
  imports: [IntroductionComponent, AboutComponent, DevservicesComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

}
